import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import BalanceHistoryPage from "./pages/BalanceHistoryPage";
import BudgetPage from "./pages/BudgetPage";
import LoginPage from "./pages/LoginPage";
import { AuthProvider, ProtectedRoute } from "./context/AuthContext";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/balance/history"
            element={
              <ProtectedRoute>
                <BalanceHistoryPage />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/budget"
            element={
              <ProtectedRoute>
                <BudgetPage />
              </ProtectedRoute>
            }
          />
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;